/**
 * Created by mac on 2018/8/23.
 */
/**
 * Created by mac on 2018/8/14.
 */
import Modal from '@/components/Modal/';
import loadingImg from '@/assets/images/img_binding_pic.png';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Immutable from 'immutable';
import { Global } from '../../constants/actionTypes';
import styles from './NoOtherAccount.scss';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import {
  setBindPhoneStatus,
  setBindWxStatus,
} from '../../actions/GlobalAction';
import IconFont from '../Icon/IconFont';
import { getState as getGlobalState } from '../../reducers/Global/GlobalReducer';

@connect(
  (state) => {
    const globalState = getGlobalState(state);
    return {
      msg: globalState.get('noOtherAccount').msg,
      step: globalState.get('noOtherAccount').step,
      data: JSON.parse(globalState.get('noOtherAccount').data),
    };
  },
  dispatch => ({
    setBindPhoneStatus: status => dispatch(setBindPhoneStatus(status)),
  }),
)
export default class NoOtherAccount extends Component {
  render() {
    const { onModalCancelClick, visible, data } = this.props;
    console.log('data', this.props);
    return (
      <Modal
        width={520}
        visible={visible}
        showFooter={false}
        maskClassName={styles['mask']}
        modalClassName={styles['modal']}
        closable
        isMiddle
        title={i18n.get('phoneModal.wxoccupy')}
        onCancel={onModalCancelClick}
      >
        <div className={styles['content']}>
          <p>{this.props.msg}</p>
        </div>
        {this.props.step === 1 && <StepOne
          username={data.target_user_nickname}
          id={data.target_user_id}
          token={data.token}
        />}
        {this.props.step === 2 && <StepTwo
          onModalCancelClick={onModalCancelClick}
          id={data.target_user_id}
          token={data.token}
          username={data.target_user_nickname}
        />}


      </Modal>);
  }
}



// WEBPACK FOOTER //
// ./src/components/HasBindMordal/NoOtherAccount.js